import './Modal.css';
import { PropsWithChildren, ReactNode, useEffect } from 'react';
import ReactModal from 'react-modal';
import { cx } from '#/Scripts/utilities/cx';

export interface BasicModalProps extends PropsWithChildren {
  isOpen: boolean;
  handleClose: () => void;
  title: string;
  footer?: ReactNode;
  className?: string;
  subheader?: ReactNode;
  shouldCloseOnOverlayClick?: boolean;
  shouldCloseOnEsc?: boolean;
  disableClose?: boolean;
}

export const Modal = ({
  isOpen,
  handleClose,
  title,
  children,
  footer,
  className,
  subheader,
  shouldCloseOnOverlayClick = true,
  shouldCloseOnEsc = true,
  disableClose = false,
}: BasicModalProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => document.body.classList.remove('modal-open');
  }, [isOpen]);

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={handleClose}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      shouldCloseOnEsc={shouldCloseOnEsc}
      className={cx('react-modal-content', className)}
      overlayClassName="react-modal-overlay"
      aria={{ labelledby: 'modal-title' }}
    >
      <div className="modal-container">
        <div className="modal-header">
          <h2 id="modal-title" className="modal-title">
            {title}
          </h2>
          <button
            type="button"
            className={cx('modal-close-x', disableClose && 'disabled')}
            onClick={handleClose}
            disabled={disableClose}
            aria-label="Close modal"
          >
            &times;
          </button>
          {subheader && <div className="modal-subheader">{subheader}</div>}
        </div>

        <div className="modal-body">{children}</div>

        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </ReactModal>
  );
};
